import { FAQPage, Question, Answer } from 'schema-dts';
import { FAQ } from '../../client/types';

export function getFAQStructuredData(faq: FAQ[]): FAQPage {
  const data: FAQPage = {
    '@type': 'FAQPage',
    mainEntity: faq.map(({ question, answer }): Question => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer,
      } as Answer,
    })),
  };

  return data;
}
